import { createFileRoute } from "@tanstack/react-router"
import { AdminSupportTicketsPage } from "../features/admin/AdminSupportTicketsPage"

export const Route = createFileRoute("/_auth/admin/support-tickets")({
  component: AdminSupportTicketsPage,
})
